import { createApi } from '@reduxjs/toolkit/query/react'
import { DELETE_CLASSROOM_REPORT, MANAGE_CLASSROOM_CONSULTATION_ADD, MANAGE_CLASSROOM_CONSULTATION_DELETE, MANAGE_CLASSROOM_CONSULTATION_EDIT, MANAGE_CLASSROOM_CONSULTATION_FEEDBACK, MANAGE_CLASSROOM_CONSULTATION_LIST, MANAGE_CLASSROOM_CONSULTATION_SUBMIT, MANAGE_CLASSROOM_CONSULTATION_VIEW, MANAGE_CLASSROOM_REPORTS_LIST, MANAGE_FAVOURITE_REPORT } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const ClassroomConsultationApi = createApi({
    reducerPath: 'ClassroomConsultationApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/classroom/plan",
    }),
    tagTypes: ["ClassroomConsultationList", "ClassroomConsultationDetail", "ClassroomConsultationFeedback"],
    endpoints: (builder) => ({

        // classroom consultation list
        getClassroomConsultationList: builder.query({
            query: ({ search = "", school = "", grade = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_CLASSROOM_CONSULTATION_LIST,
                    data: { search, page, limit, sort, status, school, grade }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClassroomConsultationList"]
        }),

        // add classroom consultation
        addClassroomConsultation: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_CLASSROOM_CONSULTATION_ADD,
                data
            }),
            invalidatesTags: ["ClassroomConsultationList"]
        }),

        // classroom consultation detail
        getClassroomConsultationDetail: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_CLASSROOM_CONSULTATION_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClassroomConsultationDetail"]
        }),

        // update classroom consultation
        updateClassroomConsultation: builder.mutation({
            query: ({ data, consultationId }) => ({
                method: "PUT",
                url: `${MANAGE_CLASSROOM_CONSULTATION_EDIT}/${consultationId}`,
                data
            }),
            invalidatesTags: ["ClassroomConsultationList", "ClassroomConsultationDetail"]
        }),

        // delete classroom consultation
        deleteClassroomConsultation: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_CLASSROOM_CONSULTATION_DELETE}/${id}`
            }),
            invalidatesTags: ["ClassroomConsultationList", "ClassroomConsultationDetail"]
        }),

        // get classroom consultation report steps
        getClassroomConsultationReportSteps: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_CLASSROOM_CONSULTATION_FEEDBACK}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClassroomConsultationFeedback"]
        }),

        // preview classroom consultation feedback
        submitClassroomConsultationFeedback: builder.mutation({
            query: ({ data, consultationId }) => ({
                method: "PUT",
                url: `${MANAGE_CLASSROOM_CONSULTATION_FEEDBACK}/${consultationId}`,
                data
            }),
            invalidatesTags: ["ClassroomConsultationDetail"]
        }),

        // preview classroom consultation final feedback
        submitClassroomConsultationFinalFeedback: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MANAGE_CLASSROOM_CONSULTATION_SUBMIT}/${id}`,
                data
            }),
            invalidatesTags: ["ClassroomConsultationList"]
        }),


        getClassroomReportsList: builder.query({
            query: ({ search = "", school = "", grade = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_CLASSROOM_REPORTS_LIST,
                    data: { search, page, limit, sort, status: status?.value, school: school?.value, grade }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ClassroomReportsList"]
        }),

        favouriteReport: builder.mutation({
            query: ({ data }) => ({
                method: "PATCH",
                url: `${MANAGE_FAVOURITE_REPORT}`,
                data
            }),
            invalidatesTags: ["ClassroomReportsList"]
        }),

        deleteClassroomReport: builder.mutation({
            query: ({ reportId }) => ({
                method: "DELETE",
                url: `${DELETE_CLASSROOM_REPORT}/${reportId}`
            }),
            invalidatesTags: ["ClassroomReportsList"]
        }),

    }),
})

export const {
    useGetClassroomConsultationListQuery,
    useAddClassroomConsultationMutation,
    useGetClassroomConsultationDetailQuery,
    useUpdateClassroomConsultationMutation,
    useDeleteClassroomConsultationMutation,
    useGetClassroomConsultationReportStepsQuery,
    useSubmitClassroomConsultationFeedbackMutation,
    useSubmitClassroomConsultationFinalFeedbackMutation,
    useGetClassroomReportsListQuery,
    useFavouriteReportMutation,
    useDeleteClassroomReportMutation

} = ClassroomConsultationApi;